import { GameZoneBounds } from 'types/global'

export const transformRatingForLabel = (rating: number) => rating.toFixed(1).replace('.0', '')

export const transformGameZoneValues = (bounds: GameZoneBounds) => ({
  min: bounds.upper,
  max: bounds.lower,
})
